<script setup lang="ts">
import { computed } from 'vue';
import type FlightSchool from '@/types/FlightSchool';
import type { PassRateReport } from '@/types/PassRateReport';
import type { CardSegment } from '@/types/CardSegment';
import CardSegments from '@/components/CardSegments.vue';

const props = defineProps<{
    school: FlightSchool,
    passRateReport: PassRateReport,
    startDate: string|null,
    endDate: string|null,
}>();

const totalFirstAttemptPassRate = computed(() => (props.passRateReport.firstTryPassRate ? `${props.passRateReport.firstTryPassRate}%` : '--'));

const cardSegments: CardSegment[] = [
    {
        iconName: 'sym_o_assignment_turned_in',
        description: 'FAA Exam Passes',
        content: computed(() => props.passRateReport.totalPassed),
    },
    {
        iconName: 'sym_o_counter_1',
        description: 'Passed on First Attempt',
        content: computed(() => props.passRateReport.firstTryPasses),
    },
    {
        iconName: 'sym_o_percent',
        description: 'Total Pass Rate',
        content: totalFirstAttemptPassRate,
    },
];

</script>
<template>
    <q-card
        id="overall-pass-rate"
        class="q-py-lg q-mt-none q-mx-sm"
        tabindex="0"
        role="region"
        :aria-label="`${school.name }'s Pass Rate Report`"
        flat
    >
        <q-card-section
            class="col q-px-lg q-py-none"
            align="left"
        >
            <div class="title q-mt-none">
                {{ school.name }}'s Pass Rate Report
            </div>
            <div
                v-if="startDate || endDate"
                class="date-range q-pt-xs"
            >
                {{ startDate }} - {{ endDate }}
            </div>
            <div class="segment-title q-py-md row">
                Overall
            </div>
        </q-card-section>
        <CardSegments
            :card-segments="cardSegments"
            :class="'q-px-lg'"
        />
    </q-card>
</template>
<style scoped lang="scss">
#overall-pass-rate {
    background: var(--fsum-white);
    min-width: fit-content;
}
.title {
    font-size: 24px;
    font-weight: 700;
    color: var(--fsum-black);
}
.segment-title {
    font-size: 20px;
    font-weight: 700;
    color: var(--fsum-black);
}
:deep(.q-btn) {
    padding-bottom: 20px;
}
</style>
